export const sideNavigationContainerStyle = {
  flexGrow: "unset",
};

export const updatePermissionsModalBodyStyles = {
  maxHeight: "352px",
};

//used to show popover over modal
export const listPopupDropdownOverlayStyles = {
  zIndex: "1150",
};

//dropdown should not be visible above sticky header and z-index of sticky header is 230
export const actionDropdownOverlayStyles = {
  zIndex: "225",
};

export const relatedAndCriticalPermissionsTooltipStyle = {
  maxWidth: "312px",
};

export const tooltipContainerStyle = {
  maxWidth: "150px",
  maxHeight: "250px",
  overflowY: "auto",
};

export const archivedStaffTooltipStyle = {
  maxWidth: "232px",
};

export const moduleSettingAtDifferentLevelTooltipStyle = {
  maxWidth: "324px",
};

export const rightPaneStyles = {
  rightPaneContainerStyle: { width: "360px", right: "-360px" },
  rightPaneHeaderStyle: { height: "52px", padding: "12px 20px" },
  rightPaneMiddleContainerStyle: {
    padding: "0px 20px 28px",
    overflowY: "auto",
  },
};

export const linkedPermissionIconStyle = {
  visibility: "hidden",
};
